import { RadioGroup, RadioGroupProps } from '@atoms/inputs';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';

export type FormRadioGroupProps<T> = Omit<RadioGroupProps, 'ref'> & {
  name: Path<T>;
};
export function FormRadioGroup<T extends FieldValues>({ name, onChange, ...props }: FormRadioGroupProps<T>) {
  const { control } = useFormContext<T>();

  return (
    <Controller<T>
      name={name}
      control={control}
      render={({ field: { onChange: onChangeForm, ...field } }) => (
        <RadioGroup
          {...props}
          {...field}
          onChange={(...args) => {
            onChangeForm(...args);
            onChange?.(...args);
          }}
        />
      )}
    />
  );
}
